import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SimilarProductCarousel from '@moncler/components/product/SimilarProductCarousel';
import Drawers from '@common/ui/drawes/Drawers';
const SimilarProductsDrawer = (props) => {
    const { t } = useTranslation();
    const drawerHead = useMemo(() => {
        var _a;
        const isOutOfStock = ((_a = props.product.availability) === null || _a === void 0 ? void 0 : _a.isOutOfStock) && !props.product.isComingSoon;
        const title = isOutOfStock ? t('label.outofstock') : t('similarproduct.title');
        const subtitle = isOutOfStock ? t('similarproduct.outofstock.description') : t('similarproduct.description');
        return (React.createElement("div", { className: "similar-product-text-container" },
            React.createElement("h2", { className: "similar-product-title" }, title),
            React.createElement("span", { className: "similar-product-subtitle" }, subtitle)));
    }, [props.product]);
    return (React.createElement(Drawers, { className: 'similar-product-modal', contentLabel: t('similarproduct.modaltitlea11y'), isOpen: props.similarModalOpen, role: "dialog", hasBackdrop: true, onRequestClose: () => {
            props.setSimilarModalOpen(false);
        }, isSticky: true },
        React.createElement(React.Fragment, null,
            drawerHead,
            React.createElement(SimilarProductCarousel, { similarProductsTiles: props.similarProductsTiles, 
                // labelVisible
                swiperConf: {
                    breakpoints: {
                        1024: {
                            enabled: false,
                            slidesPerView: 2,
                            spaceBetween: 0,
                        },
                    },
                } }))));
};
export default SimilarProductsDrawer;
